function VideoConstructor(video) {
  let sources = video.querySelectorAll('source')
  sources.forEach(source => {
    if (source.dataset.src) {
      source.src = source.dataset.src
    }
    video.load()
    // video.play()
  })

  let playPromise = video.play()

  let observer

  if (playPromise !== undefined) {
    playPromise
      .then(_ => {
        let isPaused = false
        observer = new IntersectionObserver(
          ([entry]) => {
            if (!entry.isIntersecting && !video.paused) {
              video.pause()
              isPaused = true
            } else if (isPaused) {
              video.play()
              isPaused = false
            }
          },
          {
            rootMargin: '0px',
            threshold: 0.2
          }
        )

        observer.observe(video)
      })
      .catch(error => {
        console.error(error)
      })
  }

  video.playbackRate = video.dataset.speed ? video.dataset.speed : '1'
  // console.log(video.playbackRate)
}
export default VideoConstructor
